import { render, staticRenderFns } from "./EtagForm.vue?vue&type=template&id=30b154a8"
import script from "./EtagForm.vue?vue&type=script&lang=js"
export * from "./EtagForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports